import moment from 'moment'
import _ from 'lodash'
import { countryName } from '@/services/countries'
import Url from 'url-parse'

export default {
  install(Vue, options) {
    const filtersMap = {
      capitalize,
      capitalizeArray: capitalizeArray,
      title: title,
      trim: trim,
      currency: currency,
      prettifyRound: prettifyRound,
      json: (text) => JSON.stringify(text, null, 2),
      date: dateFilter,
      dateWithHour: dateWithHour,
      join: join,
      addComma: addComma,
      countryName: countryName,
      number: number,
      cld: cloudinaryTransform,
    }

    Vue.prototype.$filters = filtersMap

    Object.keys(filtersMap).forEach((key) => {
      const filter = filtersMap[key]
      Vue.filter(key, filter)
    })
  },
}

export function trim(text, size = 20) {
  if (!text) {
    return ''
  }
  if (text.length > size) {
    return text.substring(0, size - 3) + '...'
  } else {
    return text.slice(0, size)
  }
}

function prettifyRound(val) {
  const K = 1000
  const M = 1000 * K

  return {
    0: '-',
    null: '-',
    undefined: '-',
    25000: '1-25K',
    75000: '25-75K',
    125000: '75K-125K',
    200000: '125K-200K',
    300000: '200K-300K',
    500000: '300K-500K',
    800000: '500K-800K',
    1000000: '800K-1M',
    3000000: '1M-3M',
    5000000: '3M-5M',
    10000000: '5M-10M',
    10000000000: '+10M',
  }[val]

  if (val > 10 * M) {
    return 'over 10M'
  } else if (val >= M) {
    return parseInt(val / M, 10) + 'M'
  } else if (val >= K) {
    return parseInt(val / K, 10) + 'K'
  } else {
    return val
  }
}

function title(text) {
  if (!text) return text
  return text
    .split(/\s+/)
    .map((p) => capitalize(p))
    .join(' ')
}

export function currency(text, defaultCurrency) {
  if (!text) return text
  defaultCurrency = defaultCurrency || '€'
  if (text.search(/(eur|pln|\$|€)/i) >= 0) {
    return text
  } else {
    return text + ' ' + defaultCurrency
  }
}

export function dateFilter(text, format = 'Y-MM-DD') {
  return moment(text).format(format)
}

export function dateWithHour(text) {
  return dateFilter(text, 'Y-MM-DD HH:mm')
}

function join(items, sep = ', ') {
  return items.join(sep)
}

export function roundedNumber(value) {
  const M = Math.pow(10, 6)
  const K = Math.pow(10, 3)

  if (value >= M) {
    value = value / M
    value = stripLeadingZeros(value)
    return `${value}M`
  } else if (value >= K) {
    value = value / K
    value = stripLeadingZeros(value)
    return `${value}K`
  } else {
    return `${value}`
  }
}

function stripLeadingZeros(value) {
  const fixed = value.toFixed(2)
  const num = new Number(fixed)
  return num.toString()
}

export function capitalize(value) {
  if (!value) return ''

  return _.capitalize(value)
}

function capitalizeArray(array) {
  if (!array) return ''

  return _.map(array, _.capitalize)
}

function addComma(value) {
  if (!value) return ''

  return `${value}, `
}

export function questionTypeLabel(value) {
  return {
    TEXT: 'Text',
    SINGLE_CHOICES: 'Single selection',
    MULTIPLE_CHOICES: 'Multiple selection',
    NUMBER: 'Number',
    COMPANY_PROFILE: 'Company profile',
    IMAGE: 'Image',
    YEAR_MONTH: 'Year & Month',
    ATTACHMENT: 'Attachment',
    AGREEMENT: 'Agreement',
  }[value]
}

export function moneyToNumber(value) {
  const num = value.replace(/[^\d]/g, '')
  return parseInt(num, 10)
}

export function numberToMoney(number, prefix = '', suffix = ' €') {
  const money = []
  number = new String(number).split('').reverse()
  number.forEach((ch, i) => {
    if (i > 0 && i % 3 === 0) {
      money.push(' ')
    }
    money.push(ch)
  })

  const newText = money.reverse().join('')
  return prefix + newText + suffix
}

export function number(value, decimalPlaces = 1) {
  return Number(Number(value).toFixed(decimalPlaces))
}

export function cloudinaryTransform(value, opts = {}) {
  const url = Url(value)
  if (url.host !== 'res.cloudinary.com') {
    return value
  }
  const path = url.pathname
  const parts = path.split('/')

  const optsString = (function () {
    const optsParts = []
    _.forOwn(opts, (value, key) => {
      optsParts.push(`${key}_${value}`)
    })
    return optsParts.join(',')
  })()

  if (parts.length === 6) {
    // replace version with optsstring (or leave version if no options given)
    parts[4] = optsString || parts[4]
  } else if (parts.length === 5) {
    // adds optsstring (or leave blank if not given)
    if (optsString) {
      parts.splice(4, 0, optsString)
    }
  } else {
    // throw new Error("Wrong cloudinary url")
    console.error(`Unexpected cloudinary url: ${value}`)
    return value
  }
  url.set('pathname', parts.join('/'))
  url.set('protocol', 'https:')
  return url.toString()
}
